export const ChapterPermissions = Object.freeze({
  PdmAccess: 'PDM Access',
  OrganizationAdmin: 'Organization Admin',
  OrganizationManager: 'Organization Manager',
  BakerFirst: 'Baker First',
  OrganizationPurchases: 'Organization Purchases',
  CanViewUsers: 'Can View Users',
  CanEditOrganizationUsers: 'Can Edit Organization Users',
  CanEditAllUsers: 'Can Edit All Users',
  CanViewRoles: 'Can View Roles',
  CanEditRoles: 'Can Edit Roles',
  CanViewProducts: 'Can View Products',
  CanViewAuthors: 'Can View Authors',
  CanEditProducts: 'Can Edit Products',
  CanMergeRelatedProductData: 'Can Merge Related Product Data',
  CanViewOrders: 'Can View Orders',
  CanEditOrders: 'Can Edit Orders',
  CanCancelOrders: 'Can Cancel Orders',
  CanProcessOrderReturns: 'Can Process Order Returns',
  CanArchiveOrders: 'Can Archive Orders',
  CanEditPrices: 'Can Edit Prices',
  CanViewReports: 'Can View Reports',
  CanViewNotifications: 'Can View Notifications',
  CanEditFlags: 'Can Edit Flags',
  CanViewPromotions: 'Can View Promotions',
  CanEditPromotions: 'Can Edit Promotions',
  CanViewCustomers: 'Can View Customers',
  CanEditCustomers: 'Can Edit Customers',
  CanViewAzureData: 'Can View Azure Data',
  CanEditAzureData: 'Can Edit Azure Data',
  CanEditTenants: 'Can Edit Tenants'
})
